import { MbscModule } from '@mobiscroll/angular';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { BlockUIModule } from 'ng-block-ui';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PasswordStrengthMeterComponent } from 'angular-password-strength-meter';
import { CommonModule } from '@angular/common';
import { ZxvbnConfigType, provideZxvbnServiceForPSM } from 'angular-password-strength-meter/zxcvbn';
import { PageNotFoundComponent } from './page-not-found.component';
import { SidebarComponent } from './sidebar.component';
import { HeaderComponent } from './header.component';
import { SuperAdminModule } from './super-admin/super-admin.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestInterceptorService } from './core/api-request-interceptor.service';
import { SuperAdminSettingsModule } from './super-admin-settings/super-admin-settings.module';
import { SignUpModule } from './sign-up/sign-up.module';
import { SuperAdminMemberManagementModule } from './super-admin-member-management/super-admin-member-management.module';
import { PendingApplicationsModule } from './pending-applications/pending-applications.module';
import { PendingNewsModule } from './pending-news/pending-news.module';
import { PendingLettersModule } from './pending-letters/pending-letters.module';
import { MemberNewsModule } from './member-news/member-news.module';
import { MemberInformationModule } from './public-portal/member-information/member-information.module';
import { PublicPortalHeaderComponent } from './public-portal/public-portal-header.component';
import { PublicPortalBaseComponent } from './public-portal/public-portal-base.component';
import { AdminPortalBaseComponent } from './admin-portal-base.component';
import { MemberUserManagementModule } from './member-admin/member-user-management/member-user-management.module';
import { MembershipManagementModule } from './member-admin/membership-management/membership-management.module';
import { PortalLoginModalComponent } from './public-portal/portal-login-modal.component';
import { MemberAdsModule } from './member-ads/member-ads.module';
import { MemberDiscountModule } from './member-discount/member-discount.module';
import { RouterModule } from '@angular/router';
import { MemberDashboardComponent } from './member-admin/member-dashboard/member-dashboard.component';
import { CoreModule } from './core/core.module';
import { MemberInvoicesModule } from './member-admin/member-invoices/member-invoices.module';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { SuperAdminResourcesModule } from './super-admin-resources/super-admin-resources.module';
import { PaymentHistoryModule } from './payment-history/payment-history.module';
import { PublicPaymentsModule } from './public-portal/public-payments/public-payments.module';
import { ConfirmModalComponent } from './shared/confirm-modal.component';

const zxvbnConfig: ZxvbnConfigType = {
  maxLength: 8
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PageNotFoundComponent,
    SidebarComponent,
    HeaderComponent,
    AdminPortalBaseComponent,
    PublicPortalBaseComponent,
    PublicPortalHeaderComponent,
    PortalLoginModalComponent,
    MemberDashboardComponent,
    ConfirmModalComponent,
  ],
  imports: [
    MbscModule,
    BrowserModule,
    NgbModule,
    CommonModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    BlockUIModule.forRoot(),
    ToastrModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    PasswordStrengthMeterComponent,
    SuperAdminModule,
    SuperAdminSettingsModule,
    SignUpModule,
    SuperAdminMemberManagementModule,
    MemberUserManagementModule,
    MemberInvoicesModule,
    MembershipManagementModule,
    PendingApplicationsModule,
    MemberInformationModule,
    PendingNewsModule,
    PendingLettersModule,
    MemberNewsModule,
    MemberAdsModule,
    MemberDiscountModule,
    CoreModule,
    EditorModule,
    PaymentHistoryModule,
    SuperAdminResourcesModule,
    PublicPaymentsModule
  ],
  providers: [
    provideZxvbnServiceForPSM(),
    { provide: HTTP_INTERCEPTORS, useClass: ApiRequestInterceptorService, multi: true },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
